import SharedMethodOfPayment from 'views/shared/MethodOfPayment/SharedMethodOfPayment';
import { AUTO_PAYMENT_OPTIONS } from 'views/shared/MethodOfPayment/configs';
import {
  changeBilling,
  changeMethodOfPayment,
  updatePayments,
  changeAccountHolder,
  removeMissingMandatoryField,
  changeAgencyBilling,
} from 'reducers/commercialFormReducer';

import FormInput from 'components/fields/commercial/FormInput';
import DateInput from 'components/fields/commercial/DateInput';
import SelectInput from 'components/fields/commercial/SelectInput';
import RadioInput from 'components/fields/commercial/RadioInput';

interface CommercialMethodOfPaymentProps {
  isLocked?: boolean;
}

const CommercialMethodOfPayment = ({
  isLocked = false,
}: CommercialMethodOfPaymentProps) => {
  return (
    <SharedMethodOfPayment
      formStateKey="commercialForm"
      sectionKey={0}
      paymentConfig={AUTO_PAYMENT_OPTIONS}
      isDisabled={isLocked}
      actions={{
        changeBilling,
        changeMethodOfPayment,
        updatePayments,
        changeAccountHolder,
        removeMissingMandatoryField,
        changeAgencyBilling,
      }}
      components={{
        FormInput,
        DateInput,
        SelectInput,
        RadioInput,
      }}
    />
  );
};

export default CommercialMethodOfPayment;
